import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  marketTotalHeaderNomination: {
    color: '#ffffff',
  },
  decimelStyle: {
    fontSize: 30,
  },
  currencyStyle: {
    fontSize: 32,
  }
})
